<template>
  <div class="container">
    <div>
      <img :style="style" v-for="(item,index) in qumu_picList" class="qumu-img" :src="baseUrl+item" alt="">
    </div>
    <div class="play-area">
      <div class="audio" v-for="(item,index)  in musicList">
      <div>{{ item.desc }}</div>
      <audio controls loop>
  <source :src="item.src"  type="audio/ogg">
      您的浏览器不支持 audio 元素。
</audio>

     </div>
    </div>
  </div>



</template>

<script>
import config from '../../config/config'
import { recordList, qukuAdd, qukuListAll, qukuDelete, qukuUpdate } from '../api/quku/index';
import { Notification, MessageBox, Message, Link } from "element-ui";
export default {
  name: 'Operlog',
  data () {
    return {
      baseUrl:'',
      detail:{},
      style:'',
    }
  },
  created () {
    var screenHeight = window.innerHeight;
    console.log('-------',screenHeight)
    let height = 0.9 * screenHeight + 'px';
    this.style = "height:"+height;
    this.baseUrl = config.baseUrl;
    let detail= localStorage.getItem('detail') || {}
    detail = JSON.parse(detail)
    console.log(detail)
    this.detail = detail;
    let qumu_picList = detail.qumu_pic.split(',');
    this.qumu_picList = qumu_picList
    let musicList = detail.qumu_banzou.split(',');
    let zhifaList = detail.qumu_zhifa.split(',');
    let shuomingList = detail.qumu_shuoming.split(',');
    let _list = [];
    for(let i=0;i<musicList.length;i++){
      _list.push({src:musicList[i],desc:shuomingList[i] + ' + '+zhifaList[i]})
    }
    this.musicList = _list

  },
  methods: {}
}
</script>
<style scoped>
.play-area{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

}
.container{
  display: flex;
  justify-content: center;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.gap {
  margin: 30px 10px;
}

.title {
  color: black;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.qumu-img{
  max-width: 100%;
}
.el-upload-list--picture-card .el-upload-list__item{
  width: 100px;
  height: 100px !important;
}
.el-upload--picture-card{
  width: 100px;
  height: 100px !important;
  line-height: 100;
}

.list-item{
  display: flex;
  border-bottom: 1px solid gray;
  padding: 20px;
}
.icon{
  width: 20px;
  margin-left: 10px;
}

.audio{
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/qupuDetail.vue